module.exports = __webpack_public_path__ + "media/packs/booking-system/appointment-booking/src/images/booking_thankyou-a1603199959797c3b0631ae04fb36b06.png";